import React, { FunctionComponent } from 'react';

export interface StoryCardPlaceholderProps {
  isPreview?: boolean;
}

// Shared skeleton styling (replaces the legacy `.placeholder` + @keyframes fading).
// `bar` = default gray body bars; `titleBar` = the darker step that stands in
// for the navy title lines; `circle` = round share-button placeholders.
const bar = 'animate-pulse rounded-[3px] bg-gray-200';
const titleBar = 'animate-pulse rounded-[3px] bg-gray-300';
const circle = 'animate-pulse rounded-full bg-gray-200';

export const StoryCardPlaceholder: FunctionComponent<StoryCardPlaceholderProps> = ({
  isPreview,
}) => {
  return (
    <div data-testid="report-card-placeholder" className="min-h-[90px] w-full max-w-[600px] p-4">
      <div>
        <article className="min-h-[90px] after:clear-both after:block after:content-['']">
          <header className="relative">
            <div>
              <div className={`${bar} float-right mb-2.5 ml-2.5 mt-[5px] h-20 w-20`} />
            </div>
            <h2 className="m-0 py-[5px]">
              <div className={`${titleBar} mb-[0.1em] h-[1em] w-[7em]`} />
              <div className={`${titleBar} mb-[0.1em] h-[1em] w-[8em]`} />
              <div className={`${titleBar} h-[1em] w-[6em]`} />
            </h2>
            <div className="m-0 pb-[5px] text-gray-500">
              <span>
                <time> </time>
              </span>
            </div>
          </header>
          <div className="text-[14px] leading-[1.4em]">
            <div className={`${bar} mb-[0.3em] h-[1em] w-[90%]`} />
            <div className={`${bar} mb-[0.3em] h-[1em] w-[85%]`} />
            <div className={`${bar} mb-[0.3em] h-[1em] w-[95%]`} />
            <div className={`${bar} mb-[0.3em] h-[1em] w-[95%]`} />
            <div className={`${bar} mb-[0.3em] h-[1em] w-[80%]`} />
            <div className={`${bar} mb-[0.3em] h-[1em] w-[84%]`} />
          </div>
          {!isPreview && (
            <div className="mt-8 flex flex-row justify-end">
              <div className={`${circle} mr-1.5 h-[2.6em] w-[2.6em]`} />
              <div className={`${circle} mr-1.5 h-[2.6em] w-[2.6em]`} />
              <div className={`${circle} mr-1.5 h-[2.6em] w-[2.6em]`} />
              <div className={`${circle} mr-1.5 h-[2.6em] w-[2.6em]`} />
            </div>
          )}
        </article>
      </div>
    </div>
  );
};
